<div class="flex flex-wrap items-center gap-2">
    @for (status of statusOptions(); track status) {
        <button
            type="button"
            class="p-0 bg-transparent border-none rounded-full cursor-pointer disabled:cursor-not-allowed"
            [attr.data-testid]="'request-status-toggle-' + status"
            [attr.aria-pressed]="isActive(status)"
            [disabled]="disabled()"
            (click)="toggle(status)"
        >
            <sh-tag
                class="pointer-events-none"
                [attr.data-testid]="'request-status-tag-' + status"
                [label]="'common.status.internal.' + status | translate"
                [attr.color]="isActive(status) ? colorOf(status) : null"
                [attr.active]="isActive(status) ? true : null"
                [attr.disabled]="disabled() ? true : null"
            ></sh-tag>
        </button>
    }
</div>
